import type { PipelineTapGateResolution } from "./pipelineMapTapGate";

export type PipelineMapTapDenyReason = Extract<
  PipelineTapGateResolution,
  { allowed: false }
>["reason"];

export const PIPELINE_MAP_TAP_DENY_TITLE = "Pipeline Details Unavailable";

/** User-facing copy for a denied pipeline map tap (Buxus + Studio). */
export function pipelineMapTapDenyMessage(reason: PipelineMapTapDenyReason): string {
  switch (reason) {
    case "no_jurisdiction_match":
      return "This pipeline segment is outside of your registered jurisdiction. Detailed pipeline information is not available here.";
    case "no_profile_keys":
      return "Your profile does not include jurisdiction access required to view pipeline details at this location.";
    case "no_county_state":
      return "We could not verify the location of this tap. Pipeline details are not shown.";
  }
}
